<template>
  <v-row>
    <v-col cols="12" sm="12">
      <h2 class="text--primary text-xl font-weight-medium">
        {{ $t("Henkilöstöedut") }}
      </h2>

      <v-row>
        <template v-for="b in benefits">
          <v-col lg="4" md="6" sm="12" :key="b.id">
            <v-card>
              <v-card-text class="d-flex align-center mt-5">
                <v-avatar v-if="Object.keys(b.logo).length" size="54" tile color="primary"
                  class="v-avatar-light-bg primary--text mt-1">
                  <v-img :src="b.logo.thumbnail"></v-img>
                </v-avatar>

                <div class="ms-3">
                  <h4 class="text-base font-weight-semibold">
                    {{ b.company }}
                  </h4>
                  <p class="mb-0">
                    {{ b.title }}
                  </p>
                </div>
              </v-card-text>
              <v-card-text style="white-space: pre-line;">
                {{ b.description }}
              </v-card-text>
              <template v-if="Object.keys(b.coupon_image).length">
                <v-card-actions>
                  <v-btn rounded block color="primary" @click="showCoupon(b)">
                    {{ $t("Näytä kuponki") }}
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card>
          </v-col>
        </template>
      </v-row>
      <v-dialog v-model="dialog" maxWidth="400px">
        <v-img maxHeight="75vh" contain :src="couponImage"></v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">
            {{ $t("Sulje") }}
          </v-btn>
        </v-card-actions>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { useTranslations } from "@/@core/libs/i18n";
import api from "@/api";
import useAuth from "@/useAuth";
import { getDateTime } from "@/@core/utils/datetime_helpers";

export default {
  setup() {
    const benefits = ref([]);
    const dialog = ref(false);
    const couponImage = ref("");
    const { t } = useTranslations();

    // fetch data
    const fetchBenefits = async () => {
      const response = await api.getBenefits();

      benefits.value = response.data;
    };

    const showCoupon = (benefit) => {
      couponImage.value = benefit.coupon_image.full_hd;
      dialog.value = true;
    };

    onMounted(() => {
      fetchBenefits();
    });

    return {
      t,
      benefits,
      dialog,
      couponImage,
      showCoupon,
    };
  },
};
</script>

<style></style>